import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TablePagination,
  Paper,
} from "@mui/material";
import NoDataComponent from "../../common/RecordNotFound";
import { convertToDD_MMM_YYY } from "../../utils/jsUtils";
import { FAILED_BULK_LISTING_COLUMNS } from "../../utils/constant";

const InvalidAppontmentTable = ({ appointmentDetailsList }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [maxPage, setMaxPage] = useState(0);
  const [page, setPage] = useState(0);

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  return (
    <>
      <Grid item xs={12}>
        <>
          {appointmentDetailsList === undefined ||
          appointmentDetailsList === null ||
          appointmentDetailsList.length === 0 ? (
            <Box py={5}>
              <NoDataComponent />
            </Box>
          ) : (
            <>
              <Paper>
                <TableContainer sx={{ maxHeight: 720 }}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    className="tableScroll"
                  >
                    <TableHead>
                      <TableRow>
                        {FAILED_BULK_LISTING_COLUMNS.map((column) => (
                          <TableCell
                            size="small"
                            variant="head"
                            key={column.id}
                            className="tableHeader"
                            sx={{ pt: 1.5, pb: 1.5, fontSize: "13px" }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ mt: 2 }}>
                      {appointmentDetailsList
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={`${row.siteId}${index} `}
                            >
                              {" "}
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                }}
                              >
                                {!!row["appointmentDate"]
                                  ? convertToDD_MMM_YYY(row["appointmentDate"])
                                  : "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                }}
                              >
                                {!!row["poNumber"] ? row["poNumber"] : "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontWeight: 500,
                                }}
                              >
                                {!!row["message"] ? row["message"] : "-"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={appointmentDetailsList?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </>
          )}
        </>
      </Grid>
      {/* </Container> */}
    </>
  );
};
export default InvalidAppontmentTable;
